<script>
const axios = require('axios');
export default {
  props:{
    list: null,
    owner: null,
    isValidating: false,
    label: null,
  },
  emits: {
    onUpdate: null,
  },
  data() {
    return {
      isLoading: false,
      uuid: null,
      data: null
    }
  },
  watch: {
    uuid(){
      if(this.uuid){
        localStorage.setItem(this.storageKey(), this.uuid)
        this.checkStatus(this.uuid)
      }else{
        localStorage.removeItem(this.storageKey())
      }
    }
  },
  methods: {

    checkStatus(uuid){
      this.isLoading = true
      setTimeout(() => {
        this.requestStatusUpdate(uuid)
      }, 5000)
    },

    requestCheck(){
      this.isLoading = true
      axios.get(`${this.basePath()}lists/request_items_check`,  {
        params: {
          list: this.list,
          owner: this.owner
        }
      }).then(response => {
        if(response.data.uuid){
          this.uuid = response.data.uuid
        }else{
          this.isLoading = false
        }
      }).catch(error => {
        this.isLoading = false
      }).finally(() => {

      })
    },
    requestStatusUpdate(uuid){
      axios.get(`${this.basePath()}lists/check_request_status`,  {
        params: {
          uuid: uuid,
        }
      }).then(response => {
        this.data = response.data
        if(response.data.status === 'done'){
          this.isLoading = false;
          this.uuid = null

          this.$emit('onUpdate')
        }else if(response.data.status){
          this.checkStatus(uuid)
        }


      }).catch(error => {
        this.isLoading = false
        this.uuid = null
      }).finally(() => {

      })
    },
    storageKey(){
      return `listCheckQ-${this.list}-${this.owner}`
    }
  },
  mounted() {
    let uuid = localStorage.getItem(this.storageKey());
    if(uuid){
      this.uuid = uuid
    }
  }
}
</script>

<template>
  <button @click="requestCheck" type="button" class="btn btn-light d-flex gap-2 align-items-center" :disabled="isLoading || isValidating">
    <i class="ph ph-user-check"></i> {{ this.label || $t('lists: check list data') }}
    <div class="spinner-border spinner-border-sm" role="status" v-if="isLoading || isValidating">
      <span class="visually-hidden">Loading...</span>
    </div>
  </button>
</template>

<style scoped>

</style>